import htmlToDom from '../../helpers/htmlToDom';
import makeOilspotOrderElement from './makeOilspotOrderElement';

export default (value) => {
	let downloadLink = `/orderHistory/downloadPurchaseOrder?id=${value.id}`;
	if (value.franchise !== undefined) {
		downloadLink += `&franchise=${value.franchise}`;
	}

	let products = '';
	if (value.items != undefined)
	{
		products = value.items
			.map(makeOilspotOrderElement)
			.map((el) => el.outerHTML)
			.join('');
	}

	return htmlToDom(`
		<li class="order-history__item order-history__oilspot">
			<div class="order-history__item-shop-block">
				<div class="order-history__item-info">
					<p>Дата покупки: ${value.closed_at}</p>
					<p>Магазин: ${value.name}</p>
					<p>Пробег: ${value.mileage ? value.mileage : '-'}</p>
					
				</div>
				<div class="order-history__item-employee">
					<img class="order-history__item-avatar" src=${
						value.avatarPath
							? value.avatarPath
							: `/static/images/default-catalog-image.png`
					}>
					<p>Продавец: ${value.seller_name}</p>
				</div>
			</div>
			<div class="order-history__oilspot-list-header">
				<p class="order-hitory__table-name">Наименование</p>
				<p class="order-hitory__table-count">Количество</p>
				<p class="order-hitory__table-price">Цена</p>
			</div>
			<ul>
				${products}
			</ul>
			<div class="order-history__item-price-block">
				<p class="order-history__item-price">Цена: ${Math.ceil(value.sum)} руб.</p>
				<a class="order-history__item-download" href=${downloadLink}>Скачать историю обслуживания</a>
			</div>
		</li>
	`);
};
